import PropTypes from 'prop-types';
import { creatorType } from '~/types/creator';

export const invitationType = PropTypes.shape({
  id: PropTypes.string,
  status: PropTypes.string,
  creator: creatorType,
  handle: PropTypes.string,
  email: PropTypes.string,
  pitch: PropTypes.string,
  inviteCode: PropTypes.string,
  sentAt: PropTypes.string,
  createdAt: PropTypes.string,
  profile: PropTypes.shape({
    name: PropTypes.string,
    profilePicUrl: PropTypes.string,
    followersCount: PropTypes.number,
    followsCount: PropTypes.number,
    mediaCount: PropTypes.number,
  }),
});
